var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader w-full overflow-hidden",class:{ 'loader--visible': _vm.visible }},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pre-loader-linear"},[_c('div',{staticClass:"progress"})])
}]

export { render, staticRenderFns }